import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import ImageShow from "../components/ImageShow";
import Link from "../components/Link";
import PanelBlock from "../components/PanelBlock";
import { ENABLE_INVESTING_ACCOUNT_CONTROLLER, ENABLE_UNIFIED_UPLOAD } from "../constants/constants";
import useModal from "../hooks/use-modal";
import useNavigation from "../hooks/use-navigation";
import { UNIFIED_UPLOAD_PATH } from "./UnifiedUploadPage";

function Tax() {
  const { t } = useTranslation();
  const { showModal, modal, handleModalClick } = useModal();

  const { navigate } = useNavigation();
  const unifiedEntry = ENABLE_UNIFIED_UPLOAD && ENABLE_INVESTING_ACCOUNT_CONTROLLER;

  useEffect(() => {
    if (unifiedEntry) {
      navigate(UNIFIED_UPLOAD_PATH, { replace: true });
    }
  }, [unifiedEntry, navigate]);

  const heading = t('accounts.selectBroker');

  if (unifiedEntry) {
    return null;
  }

  return (
    <div className="page">
      <h1 className="text-black text-2xl pb-[90px]">{t('accounts.title')}</h1>
      <PanelBlock heading={heading}>
        <Link
          handleClick={handleModalClick}
          to="/download"
          broker="freedom"
          className="text-black mb-5 rounded-2xl p-5 bg-white inline-block text-base mr-5">
          <ImageShow image={{ url: "freedom", label: "Freedom" }} className={"pointer-events-none mr-2"} />
         {t('accounts.brokers.freedom')}
        </Link>
        <Link
          handleClick={handleModalClick}
          to="/download"
          broker="interactive"
          className="text-black rounded-2xl p-5 bg-white inline-block text-base">
          <ImageShow image={{ url: "interactive", label: "Interactive" }} className={"pointer-events-none mr-2"} />
          {t('accounts.brokers.interactive')}
        </Link>
      </PanelBlock>
      <Link
        onClick={(e) => e.preventDefault()}
        to="/add-broker"
        className="underline underline-offset-2 text-gray-350 text-sm flex justify-end pt-2">
        {t('accounts.addBroker')}
      </Link>
      {showModal && modal}
    </div>
  );
}

export default Tax;
